<template>
  <div class="list" @click.stop="show">
    <div class="list-header">
      <h2>请选择您与对方的私信<span>（最多10条）</span></h2>
      <div class="close-icon" @click="closeToast">
        <Icon name="cross" />
      </div>
    </div>
    <Stance type="message" :show-info="false" descText="没有私信记录欧~" v-if="letterList.length === 0 && !loading" />
    <Skeleton title :row="3" :loading="loading" v-else>
      <div class="list-wrap" v-if="letterList.length > 0">
        <letter-list
          :list="letterList"
          @select="select"
          v-if="letterList.length > 0"
          :curSelect="currentSelected"
          @to-bottom="fetchMore"
        >
        </letter-list>
      </div>
    </Skeleton>
    <z-button size="large" type="primary" :disabled="currentSelected.length === 0" @click="commit">{{btnText}}</z-button>
  </div>
</template>

<script>
import { Stance, Icon, Skeleton, Button } from '@zz-common/zz-ui'
import { getonlinemsg, getuserpic } from '@api/resourceApi'
import LetterList from './LetterList'
import { toast } from '../../../native'
import { getCookie } from '../../../lib/utils'

const DEFAULT_PAGE_SIZE = 15
const MAX_CHOICE_COUNT = 10 //最大多选数
export default {
  name: 'ReportLetterList',
  props: ['beReportedUid'],
  data() {
    return {
      count: 0,
      isLoading: false,
      currentSelected: [],
      PageNo: 1,
      letterList: [],
      fetchLoading: true,
      loading: true,
      isPageEnd: false,
      firstDisaplay: true,
      objectPic: {},
      uid: getCookie('uid'),
      timeStamp: ''
    }
  },
  computed: {
    btnText() {
      if (this.currentSelected.length > 0) return '下一步'
      return '请选择要举报的私信'
    }
    // emptyData () {
    //   return this.letterList.length === 0;
    // }
  },
  mounted() {
    this.init()
  },
  methods: {
    show() {
      console.log('点击内部遮罩层不关闭')
    },
    onRefresh() {
      setTimeout(() => {
        this.$toast('刷新成功')
        this.isLoading = false
        this.count++
      }, 500)
    },
    init() {
      console.log('.....proli', this.letterList)
      this.getLetterInfo()
      this.getuserpic()
      //this.getProductInfo();
    },
    select(item) {
      if (this.currentSelected.indexOf(item) > -1) {
        this.currentSelected.splice(this.currentSelected.indexOf(item), 1)
        return ''
      }
      if (
        this.currentSelected.length === MAX_CHOICE_COUNT &&
          this.currentSelected.indexOf(item) === -1
      ) {
        return this.$toast(`您最多可以举报${MAX_CHOICE_COUNT}条私信`)
      }
      this.currentSelected.push(item)
    },
    commit() {
      // this.logout()
      console.log('commit>>>', this.letterList)
      window.sessionStorage.setItem('letterList', JSON.stringify(this.letterList))
      this.$emit('selected', this.currentSelected)
    },
    fetchMore() {
      if (this.fetchLoading || this.isPageEnd) return
      this.getLetterInfo(this.timeStamp).then((data) => {
        if (data && data.length <= 0) {
          this.isPageEnd = true
        }
      })
    },
    closeToast() {
      //this.logout();
      this.$emit('close')
    },
    //获取头像
    getuserpic() {
      this.fetchLoading = true
      return getuserpic({
        uid: getCookie('uid'),
        toUid: this.beReportedUid
      })
        .then((res) => {
          this.fetchLoading = false
          this.objectPic = Object.assign(res[0], res[1])
          return res
        })
        .catch((err) => {
          this.fetchLoading = false
          console.error('---login--error', err)
          if (!err.errMsg) return
          toast({
            msg: err.errMsg,
            style: '2'
          })
        })
    },
    // //登陆
    // login() {
    //   this.fetchLoading = true
    //   return imUserLogin({
    //     pc_code: 'm', //区分客户端还是pc端
    //     client_version: '103.5.3',
    //     uid: getCookie('uid'),
    //     token: '97fff7be9dd16005a6f81909cad28df4a34ff3b5',
    //     source: '21'
    //   })
    //     .then((res) => {
    //       this.fetchLoading = false
    //       console.log('---login--suess', res.code)
    //       this.getLetterInfo()
    //       return res
    //     })
    //     .catch((err) => {
    //       this.fetchLoading = false
    //       console.error('---login--error--', err)
    //       if (!err.errMsg) return
    //       toast({
    //         msg: err.errMsg,
    //         style: '2'
    //       })
    //     })
    // },
    // //登出
    // logout() {
    //   this.fetchLoading = true
    //   return imUserLogout({
    //     uid: getCookie('uid'),
    //     source: '21'
    //   })
    //     .then((res) => {
    //       this.fetchLoading = false
    //       console.log('-----logout--', res)
    //       return res
    //     })
    //     .catch((err) => {
    //       this.fetchLoading = false
    //       console.error(err)
    //       if (!err.errMsg) return
    //       toast({
    //         msg: err.errMsg,
    //         style: '2'
    //       })
    //     })
    // },
    //获取信息
    getLetterInfo(timeStamp = '1565162000') {
      this.fetchLoading = true
      return getonlinemsg({
        uid: getCookie('uid'),
        contact_uid: this.beReportedUid,
        user_type: 'n',
        source: '21',
        msg_count: DEFAULT_PAGE_SIZE,
        start_timestamp: timeStamp
      })
        .then((res) => {
          this.fetchLoading = false
          console.log('-----letterInfo--', res)
          const msgData = res.protocol_content.msg_data
          //res.reverse();
          this.handleLettleData(msgData)
          this.loading = false
          //this.letterList = this.letterList.concat(res);
          return res
        })
        .catch((err) => {
          this.fetchLoading = false
          this.loading = false
          console.error(err)
          if (!err.errMsg) return
          toast({
            msg: err.errMsg,
            style: '2'
          })
        })
    },
    handleLettleData(list) {
      list.forEach((item) => {
        const portrait = this.objectPic[item.from_uid]
        if (item.msg_content.text !== '') {
          this.letterList.push({
            timeStamp: item.timestamp,
            clientMsgId: item.client_msg_id,
            msgId: item.msg_id,
            userId: item.from_uid,
            type: '1',
            portrait,
            content: item.msg_content.text
          })
        } else {
          const { capimg = '' } = item.msg_content
          const { url = '' } = capimg
          if (capimg && url !== '') {
            this.letterList.push({
              timeStamp: item.timestamp,
              clientMsgId: item.client_msg_id,
              msgId: item.msg_id,
              userId: item.from_uid,
              type: '2',
              portrait,
              content: url.indexOf('http') > -1 ? url : 'https://' + url
            })
          }
        }
      })
      if (list.length > 0) this.timeStamp = list[list.length - 1].timestamp
    }
  },
  components: {
    LetterList,
    Stance,
    zButton: Button,
    Icon,
    Skeleton
  }
}
</script>

<style lang="less" scoped>
  @import 'index.less';
</style>
